import { PmiButton } from 'shell/components/shared/button';
import { Card, CardActions, CardContent, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { alphanumericRegex, nameSurnameMoreCharactersAccentsRegex } from 'shell/constants/regex';
import Form from './form';
import { noop } from 'shell/utils/noop';

const validationSchema = yup.object({
  practice: yup.string().nullable().required('Campo obbligatorio'),
  code: yup
    .string()
    .nullable()
    .matches(alphanumericRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio'),
  descriptionBrief: yup
    .string()
    .nullable()
    .matches(nameSurnameMoreCharactersAccentsRegex, 'Il campo è alfanumerico'),
  description: yup
    .string()
    .nullable()
    .matches(nameSurnameMoreCharactersAccentsRegex, 'Il campo è alfanumerico'),
});

export interface FormTypeOperationVM {
  practice?: string;
  code?: string;
  descriptionBrief?: string;
  description?: string;
  typeDocument?: string;
  printDoc?: string;
  codeMovement?: string;
  inUse?: string;
}

interface FormTypeOperationProps {
  disabled?: boolean;
  title: string;
  isEdit?: boolean;
  onCancel: () => void;
  initialValues?: FormTypeOperationVM;
  onSubmit?: (values: FormTypeOperationVM) => void;
}

const FormTypeOperationComponent = ({
  disabled,
  title,
  isEdit,
  onCancel,
  initialValues,
  onSubmit,
}: FormTypeOperationProps): ReactElement => {
  const form = useFormik<FormTypeOperationVM>({
    initialValues: initialValues || {
      practice: undefined,
      code: undefined,
      descriptionBrief: undefined,
      description: undefined,
      typeDocument: undefined,
      printDoc: undefined,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit || noop,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={form.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Form
              values={form.values}
              onChange={form.setFieldValue}
              disabled={disabled}
              isEdit={isEdit}
              touched={form.touched}
              errors={form.errors}
            />
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormTypeOperationComponent.displayName = 'Form Type operation Page component';

const FormTypeOperation = memo(FormTypeOperationComponent);

export default FormTypeOperation;
